import React from "react";
import ReactDOM from "react-dom";
import GoogleAnalyticsWebpack from "../analytics/GoogleAnalytics";
window.React = React;
window.ReactDOM = ReactDOM;
window.GoogleAnalytics = GoogleAnalyticsWebpack;